import React, { useState } from 'react';
import GradPackageTable from './gradPackageTable';
import GradPackageOverview from './gradPackageOverview';

const tabTypes = ['Overview', 'Compare'];

const GradPackageTabs = ({ packageList, productList, pageContentData, hsPaymentPromo, altImage, googleAnalytics }) => {
    const [active, setActive] = useState(tabTypes[0]);

    const setActiveTab = (e, tabType) => {
        e.preventDefault();
        setActive(tabType);
    }
    
    return (
        <>
            {
                packageList?.length > 0 && 
                <div className='container-fluid mt-5'>
                    <h4 className='pb-3 group-name'>
						{pageContentData?.title}
						<span className="ml-2 pl-2 group-description">{pageContentData?.shortDescription}</span>
					</h4>

                    <ul className="nav nav-tabs package-tabs">
                        {tabTypes.map(type => (
                            <li className="nav-item" key={type}>
                                <a className={`nav-link ${type === active ? 'active':''}`} onClick={(e) => setActiveTab(e, type)} href="#">{type}</a>
                            </li>
                        ))}
                    </ul>

                    <div className="package-tabs-content">
                        {
                            {
                                'Overview': <GradPackageOverview packageList={packageList} productList={productList} hsPaymentPromo={hsPaymentPromo} altImage={altImage} googleAnalytics={googleAnalytics} pageContentData={pageContentData} />,
                                'Compare': <GradPackageTable packageList={packageList} productList={productList} pageContentData={pageContentData} googleAnalytics={googleAnalytics} />
                            }[active]
                        }
                    </div>
                </div>
            }
        </>
    );
}

export default GradPackageTabs;